import * as yup from "yup";

export const DaysOffValidationSchema = yup.object({
  weekend: yup.object({
    isSaturdayOff: yup.boolean().required(),
    isSundayOff: yup.boolean().required()
  }),
  holidays: yup.array().of(
    yup
      .object({
        id: yup.string().nullable(),
        name: yup.string().required("Field is required"),
        dateRange: yup.array().nonNullable()
      })
      .required()
  ),
  cutoffSchedule: yup
    .array()
    .length(7)
    .of(
      yup
        .object({
          dayOfWeek: yup.number().min(0).max(6).required(),
          cutoffTime: yup
            .string()
            .matches(/^([01]\d|2[0-3]):[0-5]\d$/, "Use HH:mm")
            .required("Field is required"),
          missedCutoffOffsetDays: yup
            .number()
            .typeError("1–7")
            .integer()
            .min(1)
            .max(7)
            .required()
        })
        .required()
    )
    .required()
});
